import Vue from 'vue'
import VueRouter from 'vue-router'
import routerHelper from "../wl-core/helpers/router";
import Home from "@/views/Dashboards/views/Home";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {requiresAuth: true, noBack: true,showHeader:true},
    },
    {
        path: '/login',
        name: 'Σύνδεση',
        meta: {requiresAuth: false, noMenu: true},
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        //         // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "login" */ '../views/Login')
    },
    {
        path: '/addCallout',
        name: 'Προσθήκη Βλάβης',
        meta: {requiresAuth: true,},

        component: () => import( '../views/Events/views/AddCallout')
    },
    {
        path: '/addIssue',
        name: 'Προσθήκη Θέματος',
        meta: {requiresAuth: true},
        component: () => import( '../views/Issues/views/AddIssue')
    },
    {
        path: '/history',
        name: 'Ιστορικό',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "eventHistory" */ '../views/Events/views/EventHistory')
    },
    {
        path: '/financial/dept',
        name: 'Οικονομικές εκκρεμότητες',
        meta: {requiresAuth: true,},

        component: () => import( '../views/Financial/views/Depts')
    },
    {
        path: '/financial/dept/payments',
        name: 'Πληρωμή',
        meta: {requiresAuth: true,},

        component: () => import( '../views/Financial/views/Payments')
    },
    {
        path: '/financial/deptMoves',
        name: 'Αναλυτικές Κινήσεις',
        meta: {requiresAuth: true},
        component: () => import( '../views/Financial/views/DeptMoves')
    },


    {
        path: '/event/:id',
        name: 'Γεγονός',
        meta: {requiresAuth: true},
        component: () => import('../views/Events/views/EventPage')
    },
    {
        path: '/issues',
        name: 'Θέματα',
        meta: {requiresAuth: true},
        component: () => import('../views/Issues/views/Issues')
    },
    {
        path: '/user',
        name: "Χρήστης",
        meta: {requiresAuth: true},
        component: () => import('../views/UserDetails')
    },
    {
        path: '/buildings',
        name: "Κτήρια",
        meta: {requiresAuth: true},
        component: () => import('../views/Buildings/views/Buildings'),

    },
    {
        path: '/lifts',
        name: "Ανυψωτικά",
        meta: {requiresAuth: true},
        component: () => import('../views/Projects/views/Projects'),
    },
    {
        path: '/lift/:projectId',
        meta: {requiresAuth: true,showHeader:true},
        component: () => import('../views/Projects/views/Project'),
        children: [
            {
                path: '',
                name: 'Ανελκυστήρας',
                meta: {requiresAuth: true,showHeader:true},
                component: () => import('../views/Projects/views/ProjectDetails')
            },
            {
                name: 'Βλάβες',
                path: 'callouts',
                meta: {requiresAuth: true,showHeader:true},
                component: () => import('../views/Projects/views/ProjectEvents' ),
                props: { type: 2}
            },
            {
                name: 'Συντηρήσεις',
                path: 'maintenances',
                meta: {requiresAuth: true,showHeader:true},
                component: () => import('../views/Projects/views/ProjectEvents' ),
                props: { type: 1}
            },
            {
                name: 'Ιστορικό Κτηρίου',
                path: 'history',
                meta: {requiresAuth: true,showHeader:true},
                component: () => import('../views/Projects/views/ProjectEvents' ),
            },
            {
                name: 'Οδηγίες Απεγκλοβισμού',
                path: 'apeglovismos',
                meta: {requiresAuth: true,showHeader:true},
                component: () => import('../views/Projects/views/ProjectIntstuctions' ),
            },
            {
                name: 'Περιοδικές Εργασίες',
                path: 'periodic',
                meta: {requiresAuth: true,showHeader:true},
                component: () => import('../views/Projects/views/ProjectPeriodicTasks' ),
            }
        ]
    },
    {
        path: "/building/:id",
        component: () => import('../views/Buildings/views/Building'),
        children: [
            {
                path: '',
                name: 'Στοιχεία Κτηρίου',
                meta: {requiresAuth: true,showHeader:true},
                component: () => import('../views/Buildings/views/BuildingDetails')
            },
            {
                path: 'partnerMoves',
                name: 'Κινήσεις Πελάτη Κτηρίου',
                meta: {requiresAuth: true},
                component: () => import('../views/Buildings/views/PartnerMoves')
            },
            {
                path: 'lift/:projectId',
                component: () => import('../views/Projects/views/Project'),
                children: [
                    {
                        name: 'Στοιχεία Ανελκυστήρα',
                        path: '',
                        meta: {requiresAuth: true},
                        component: () => import('../views/Projects/views/ProjectCard'),
                    },
                ]
            }
        ],
        meta: {requiresAuth: true,showHeader:true},
        props: true
    }
];

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    routerHelper.beforeEach(to, from, next);
});


export default router
